<script setup>
const props = defineProps({ icon: Array })
</script>

<template>
  <iconify-icon :icon="icon[1]" />
</template>
